// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-dashboard-__Dashboard-module___container","tab":"src-components-dashboard-__Dashboard-module___tab"};


//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard/Dashboard.module.css
// module id = 451
// module chunks = 0